import {
    IOfferProductTemplateModel
} from "../../../../../../../models/offer/product/templates/IOfferProductTemplateModel";
import {Resources} from "../../../../../../../resources/Resources";
import {OfferProductSolutionType} from "../../../../../../../models/offer/product/solution/OfferProductSolutionType";
import {IOfferContentsTable, IOfferContentsTableEntry, IOfferContentsTableIcon} from "./IOfferContentsTable";
import {OfferProductTemplateType} from "../../../../../../../models/offer/product/templates/OfferProductTemplateType";
import {IOfferProductSolutionModel} from "../../../../../../../models/offer/product/solution/IOfferProductSolutionModel";

export class OfferContents {

    static table(templates: IOfferProductTemplateModel[]): IOfferContentsTable[] {
        let table: IOfferContentsTable[] = [
            {
                name: Resources.t("words.personalizedSeoSupport"),
                entries: [],
                type: "category"
            },
            {
                name: Resources.t("words.personalizedSeoSupport"),
                description: Resources.t("words.personalizedSeoSupportDescription"),
                entries: [],
                type: "support",
                icons: [IOfferContentsTableIcon.QUENTIN, IOfferContentsTableIcon.CELINE, IOfferContentsTableIcon.ANIS, IOfferContentsTableIcon.JULIE, IOfferContentsTableIcon.THOMAS, IOfferContentsTableIcon.TRISTAN]
            },
            {
                name: Resources.t("words.multiLanguageSites"),
                entries: [],
                type: "category"
            },
            {
                name: Resources.t("words.multiLanguageSites"),
                description: Resources.t("words.generateMultiLangContentDescription"),
                entries: [],
                addToContents: true,
                solutionType: OfferProductSolutionType.COMMUNITY,
                type: "textBool",
                boolMin: 1
            },
            {
                name: Resources.t("words.offerCreationAutomation"),
                description: Resources.t("words.offerCreationDesc"),
                entries: [],
                type: "category",
                eachMonth: true
            },
            {
                name: Resources.t("words.seoOptimizedBlogContents"),
                entries: [],
                description: Resources.t("words.generateContentDescription"),
                solutionType: OfferProductSolutionType.AI_CONTENT,
                type: "posts",
                agent: "alya"
            },
            {
                name: Resources.t("words.topicsAndClusters"),
                entries: [],
                description: Resources.t("words.topicsAndClustersDescription"),
                solutionType: OfferProductSolutionType.SEO_CLUSTER,
                type: "text"
            },
            {
                name: Resources.t("words.offerBacklinks"),
                description: Resources.t("words.offerBacklinksDesc"),
                entries: [],
                type: "category",
                eachMonth: true
            },
            {
                name: Resources.t("words.seoBacklinkEvaluation"),
                entries: [],
                description: Resources.a("words.seoBacklinkEvaluationDescription"),
                solutionType: OfferProductSolutionType.SEO_BACKLINK_EVALUATION,
                fixedValue: Resources.t("words.offerBacklinksAcquisition"),
                type: "text",
                agent: "maya"
            },
            {
                name: Resources.t("words.seoBacklinkAnalysis"),
                entries: [],
                description: Resources.t("words.seoBacklinkAnalysisDescription"),
                solutionType: OfferProductSolutionType.SEO_BACKLINK_ANALYSIS,
                type: "text"
            },
            {
                name: Resources.t("words.offerOptimization"),
                description: Resources.t("words.offerOptimizationDesc"),
                entries: [],
                type: "category",
                eachMonth: true
            },
            {
                name: Resources.t("words.automaticOptimizationProductOrCategory"),
                entries: [],
                description: Resources.t("words.automaticOptimizationProductOrCategoryDescription"),
                solutionType: OfferProductSolutionType.OPTIMIZATION_PRODUCTS_OR_CATEGORIES,
                type: "text",
                agent: "remi"
            },
            {
                name: Resources.t("words.automaticOptimization"),
                entries: [],
                description: Resources.t("words.automaticOptimizationDescription"),
                solutionType: OfferProductSolutionType.OPTIMIZATION_CONTENT,
                type: "text"
            },
            {
                name: Resources.t("words.seoContentAudit"),
                entries: [],
                description: Resources.t("words.seoContentAuditDescription"),
                solutionType: OfferProductSolutionType.SEO_PAGE_TRACKING,
                type: "text"
            },
            {
                name: Resources.t("words.offerCompetitors"),
                description: Resources.t("words.offerCompetitorsDesc"),
                entries: [],
                type: "category"
            },
            {
                name: Resources.t("words.seoCompetitorsName"),
                entries: [],
                description: Resources.t("words.seoCompetitorsDescription"),
                solutionType: OfferProductSolutionType.SEO_COMPETITORS,
                type: "text",
                agent: "marc",
                alignCenter: true
            },
            {
                name: Resources.t("words.offerLlmName"),
                entries: [],
                description: Resources.t("words.offerSolutionDescription25"),
                solutionType: OfferProductSolutionType.LLM_PROMPTS,
                type: "text",
                agent: "marc",
                alignCenter: true
            },
            {
                name: Resources.t("words.offerAuditsResearch"),
                description: Resources.t("words.offerTrackingDesc"),
                entries: [],
                type: "category",
                eachMonth: true
            },
            {
                name: Resources.t("words.seoAuditName"),
                entries: [],
                description: Resources.t("words.seoAuditDescription"),
                solutionType: OfferProductSolutionType.SEO_AUDIT,
                type: "text",
                agent: "nox"
            },
            /*
            {
                name: Resources.t("words.integrationWithYourSite"),
                description: Resources.t("words.connectYourSiteDescription"),
                addToContents: true,
                entries: [],
                solutionType: undefined,
                type: "bool",
                icons: [IOfferContentsTableIcon.PRESTASHOP, IOfferContentsTableIcon.SHOPIFY, IOfferContentsTableIcon.WORDPRESS, IOfferContentsTableIcon.WIX, IOfferContentsTableIcon.WEBFLOW]
            },
            {
                name: Resources.t("words.googleSearchConsole"),
                description: Resources.t("words.googleSearchConsoleDescription"),
                entries: [],
                solutionType: undefined,
                type: "bool",
                icons: [IOfferContentsTableIcon.GSC]
            },
            {
                name: Resources.t("words.teamMembers"),
                entries: [
                    {value: `<span>1</span> ${Resources.t("words.singleMember")}`},
                    {value: `<span>3</span> ${Resources.t("words.multipleMembers")}`},
                    {value: `<span>10</span> ${Resources.t("words.multipleMembers")}`}
                ],
                entriesCustom: true,
                description: Resources.t("words.teamMembersDescription"),
                solutionType: undefined,
                addToContents: true,
                type: "text"
            },

             */
        ];

        templates.forEach(product => {
            let bundle = product.bundle;
            table.forEach(tableLine => {
                let solution = bundle.solutions.find(value => value.type == tableLine.solutionType);
                let entry: IOfferContentsTableEntry = {templateId: product.id};
                switch (tableLine.type) {
                    case "text":
                        if (tableLine.fixedValue) {
                            entry.value = tableLine.fixedValue;
                        } else if (solution) {
                            entry.value = solution.quantityInitial > 0 ? `<span>${solution.quantityInitial}</span> ${Resources.t(`words.offerSolution${OfferContents.solution(product.type)}${solution.type}`)}` : undefined;
                        }
                        break;
                    case "textBool":
                        if (solution && solution.quantityInitial > tableLine.boolMin) {
                            if (solution.quantityInitial >= 50) {
                                entry.value = Resources.t("words.unlimitedLanguagesAndSites");
                            } else {
                                entry.value = `<span>${solution.quantityInitial}</span> ${Resources.t(`words.offerSolution${OfferContents.solution(product.type)}${solution.type}`)}`;
                            }
                        }
                        break;
                    case "bool":
                        if (solution) {
                            if (solution.quantityInitial > tableLine.boolMin) {
                                entry.value = true;
                            }
                        } else {
                            entry.value = true;
                        }
                        break;
                    case "posts":
                        if (solution) {
                            entry.value = `<span>${solution.quantityInitial}</span> ${Resources.t(`words.offerSolution${OfferContents.solution(product.type)}${solution.type}`)}`;
                        }
                        break;
                    case "support":
                        entry.value = Resources.t(`words.offerSupport${OfferContents.supportKey(product.type)}`);
                        break;
                }

                if (!tableLine.entriesCustom && tableLine.entries)
                    tableLine.entries.push(entry);
            })
        })

        return table;
    }

    static flagTypes(): OfferProductSolutionType[] {
        return [OfferProductSolutionType.CANNIBALIZATION, OfferProductSolutionType.AGENCY];
    }

    static solutionSummary(templateType: OfferProductTemplateType, solution: IOfferProductSolutionModel): string {
        let label = Resources.t(`words.offerSolution${OfferContents.solution(templateType)}${solution.type}`);
        return OfferContents.flagTypes().includes(solution.type) ? label : `${solution.quantity} ${label}`;
    }

    static hiddenTypes(): OfferProductSolutionType[] {
        return [OfferProductSolutionType.WRITING_STYLE, OfferProductSolutionType.SEO_BACKLINKS, OfferProductSolutionType.SEO_BACKLINK_ANALYSIS, OfferProductSolutionType.COMMUNITY, OfferProductSolutionType.SEO_BACKLINK_CAMPAIGN, OfferProductSolutionType.SEO_BACKLINK_EVALUATION, OfferProductSolutionType.SEO_COMPETITORS_ANALYZE];
    }

    static addons(): OfferProductSolutionType[] {
        return [OfferProductSolutionType.IMAGES_OPTIMIZATION, OfferProductSolutionType.INDEXATION];
    }

    static popularTemplates(): string[] {
        return ["17778c6ca54349a69a4999ca218aced9"];
    }

    static contents(baseContents: string[], template: IOfferProductTemplateModel): string[] {
        let table = this.table([template]);
        table.forEach(tableLine => {
            if (tableLine.addToContents) {
                let value = tableLine.entries.find(value => value.templateId == template.id)?.value;

                if (value !== undefined) {
                    if (!value || tableLine.type == "bool") {
                        value = tableLine.name;
                    }

                    baseContents.push(value);
                }
            }
        });
        return baseContents;
    }

    static solution(type: OfferProductTemplateType): OfferProductTemplateType {
        switch (type) {
            case OfferProductTemplateType.BLOG_ESSENTIEL_LEGACY:
                return OfferProductTemplateType.OFFER_ESSENTIEL;
            case OfferProductTemplateType.BLOG_PRO_LEGACY:
                return OfferProductTemplateType.OFFER_PRO;
            case OfferProductTemplateType.BLOG_ENTREPRISE_LEGACY:
                return OfferProductTemplateType.OFFER_MAX;
        }

        return type;
    }

    static supportKey(type: OfferProductTemplateType): string {
        switch (type) {
            case OfferProductTemplateType.OFFER_PRO:
            case OfferProductTemplateType.BLOG_PRO_LEGACY:
                return "Pro";
            case OfferProductTemplateType.OFFER_MAX:
            case OfferProductTemplateType.BLOG_ENTREPRISE_LEGACY:
                return "Max";
            case OfferProductTemplateType.OFFER_ENTERPRISE:
            case OfferProductTemplateType.OFFER_AGENCY:
                return "Enterprise";
            default:
                return "Pro";
        }
    }
}